import gjsingh from "../assets//orgPics/gjsingh.png";
import bedi from "../assets/orgPics/bedi.png";
import rkp from "../assets/orgPics/rkpinjala.png";
import dheepak from "../assets/orgPics/dheepak.png";
import jayanta from "../assets/orgPics/jayantadas.png";
import sarv from "../assets/orgPics/saravanan.png";
import andrew from "../assets/orgPics/andrew.png";
import devendra from "../assets/orgPics/devendra.png";
import malay from "../assets/orgPics/malay.png";
import shoaib from "../assets/orgPics/shoaib.png";
import desai from "../assets/orgPics/desai.png";
import ravul from "../assets/orgPics/ravul.png";
import robbie from "../assets/orgPics/robbie.png";

import male from "../assets/orgPics/male.png";
import female from "../assets/orgPics/female.png";

export const organizers = [
  {
    sectionTitle: "Executive Committe 2024-2026",
    members: [
      {
        userImage: dheepak,
        name: "Dr. Andrew Dheepak Selvaraj",
        designation:
          "Immediate Past President & Chairman of the Governing Council",
      },
      {
        userImage: desai,
        name: "Dr. Sanjay Desai",
        designation: "President - VAI",
      },
      {
        userImage: gjsingh,
        name: "Dr. Gulshan Jit Singh",
        designation: "Vice President - VAI",
      },
      {
        userImage: jayanta,
        name: "Dr. Jayanta Das",
        designation: "Secretary – VAI",
      },
      {
        userImage: robbie,
        name: "Dr. Robbie K George",
        designation: "Treasurer – VAI",
      },
      {
        userImage: sarv,
        name: "Dr. Sunderaraj Saravanan",
        designation: "Past President",
      },
      {
        userImage: rkp,
        name: "Dr. Pinjala Ramakrishna",
        designation: "Past President",
      },
      {
        userImage: malay,
        name: "Dr. Malay Patel",
        designation: "Past President",
      },
      {
        userImage: shoaib,
        name: "Dr. Shoaib F Padaria",
        designation: "Past President",
      },
      {
        userImage: devendra,
        name: "Dr Devendra B. Dekiwadia",
        designation: "Past President",
      },
      {
        userImage: ravul,
        name: "Dr. Ravul Jindal",
        designation: "Past President",
      },
      {
        userImage: andrew,
        name: "Dr. Roy Varghese",
        designation: "Past President",
      },
      {
        userImage: bedi,
        name: "Dr. Harinder Singh Bedi",
        designation: "Past President",
      },
    ],
  },
  {
    sectionTitle: "National  Executive Committee(EC) Members",
    members: [
      {
        userImage: male,
        name: "Dr. Zubair Rashid",
      },
      {
        userImage: male,
        name: "Muneer Ahmad Para",
      },
      {
        userImage: male,
        name: "Dr. Brijesh Singh",
      },
      {
        userImage: male,
        name: "Dr. Ajay Khanna",
      },
      {
        userImage: female,
        name: "Dr. Pritee Sharma",
      },
      {
        userImage: male,
        name: "Dr. Viswanath Atreyapurapu",
      },
      {
        userImage: male,
        name: "Dr. Chandrashekar A. R",
      },
      {
        userImage: male,
        name: "Dr. Nihar Ranjan Pardhan",
      },
    ],
  },
  {
    sectionTitle: "International Members",
    members: [
      {
        userImage: male,
        name: "Dr. Malouf G. Mark",
        designation: "Australia",
      },
      {
        userImage: male,
        name: "Dr. J.F. UHL",
        designation: "France",
      },
      {
        userImage: male,
        name: "Dr. J.P. Benigni",
        designation: "France",
      },
      {
        userImage: male,
        name: "Dr. Emad Hussein",
        designation: "Egypt",
      },
    ],
  },
  {
    sectionTitle: "Invited Members",
    members: [
      {
        userImage: male,
        name: "Dr. Nick Morrison",
        designation: "USA",
      },
    ],
  },
];
